import { redirectToBusinessAccountApp, redirectOnExit } from '../../utils/redirectUtils';
import { NAVIGATE_TO_BAA, BUSINESS_UUID, NAVIGATE_TO_EXIT } from '../../utils/constants';

const redirectActionMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  if (action.redirect) {
    const configObj = store.getState().config;
    const businessId = store.getState().dataCapture.get(BUSINESS_UUID);
    const bank_id = configObj.get('bank_id');
    const redirect_uri = configObj.get('redirect_uri');
    const { navigation } = action.redirect;

    if (action.redirect.to.length > 0) {
      switch (action.redirect.to) {
        case NAVIGATE_TO_BAA:
          redirectToBusinessAccountApp(redirect_uri, businessId, navigation);
          break;
        case NAVIGATE_TO_EXIT:
          redirectOnExit(bank_id);
          break;
        default:
          break;
      }
    }
  }
  return result;
};
export default redirectActionMiddleware;
